const ICON_STYLE = {
  width: 28,
  height: 28,
  display: "block",
};

function Base({ children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="28"
      height="28"
      aria-hidden="true"
      focusable="false"
      style={ICON_STYLE}
      {...props}
    >
      {children}
    </svg>
  );
}

export default function ServiceIcon({ name }) {
  switch (name) {
    case "cardiology":
      return (
        <Base>
          <path
            d="M12 20s-7-4.7-9.2-8.9C1 8.3 2.6 5.7 5.5 5.2c1.7-.3 3.2.4 4 1.7.8-1.3 2.3-2 4-1.7 2.9.5 4.5 3.1 2.7 5.9C19 15.3 12 20 12 20Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "ent":
      return (
        <Base>
          <path
            d="M13 5c2.4 0 4 1.7 4 4.2 0 1.8-.8 2.8-1.6 3.7-.7.8-1.4 1.5-1.4 2.8 0 1.9-1.4 3.3-3.2 3.3-1.6 0-2.8-1-3.1-2.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M8.3 14.4c.5-.8 1.5-1.4 2.7-1.4 1.7 0 3 1.2 3 2.8 0 1.2-.9 2.2-2.2 2.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "gastroenterology":
      return (
        <Base>
          <path
            d="M10 6c0 2.3-1.7 2.7-1.7 4.4 0 1.4 1 2.6 2.4 2.6h1.1c1.8 0 3.2 1.4 3.2 3.2V18c0 .6-.4 1-1 1h-1.6c-2.8 0-5-2.2-5-5v-3.6C7.4 8.4 8.7 7.2 10 6Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "internal-medicine":
      return (
        <Base>
          <path
            d="M12 3v18M3 12h18"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M8 8h8v8H8z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "nephrology":
      return (
        <Base>
          <path
            d="M8.8 5.6c-1.9 0-3.3 1.9-3.3 4.1 0 2 1 3.6 2.7 4.1.8.2 1.3.9 1.3 1.7V19h1.8v-3.4c0-1 .7-1.8 1.7-1.9 2.3-.2 4-2.2 4-4.8 0-2.2-1.4-4.1-3.3-4.1-1.1 0-2 .6-2.6 1.6-.6-1-1.5-1.6-2.3-1.6Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "ophthalmology":
      return (
        <Base>
          <path
            d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6S2.5 12 2.5 12Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </Base>
      );

    case "pediatrics":
      return (
        <Base>
          <path
            d="M12 20a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M9.2 12.2h.01M14.8 12.2h.01"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M9.5 15.2c.8.8 1.7 1.2 2.5 1.2s1.7-.4 2.5-1.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "preventive":
      return (
        <Base>
          <path
            d="M12 3l7 4v6c0 5-3.5 8-7 8s-7-3-7-8V7l7-4Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M12 7v8M8 11h8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "diagnostics":
      return (
        <Base>
          <circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M16 16l5 5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M8.5 11h5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "laboratory":
      return (
        <Base>
          <path
            d="M10 3v6l-4.5 8.2A3 3 0 0 0 8.1 21h7.8a3 3 0 0 0 2.6-3.8L14 9V3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M8.2 14h7.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "general-surgery":
      return (
        <Base>
          <path
            d="M5 19l10-10"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M14 5l5 5-2.2 2.2-5-5L14 5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M4 20h5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "orthopedics":
      return (
        <Base>
          <path
            d="M7.2 8.2a2.2 2.2 0 1 1 3.1-3.1l6.5 6.5a2.2 2.2 0 1 1-3.1 3.1L7.2 8.2Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M6.4 9l-1.2 1.2a2 2 0 0 0 0 2.8l.6.6M17.6 15l1.2-1.2a2 2 0 0 0 0-2.8l-.6-.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "urology":
      return (
        <Base>
          <path
            d="M8.5 5.5c-1.9 0-3.5 1.9-3.5 4.2 0 2.2 1.2 4 3 4.5.8.2 1.4.9 1.4 1.8v3h2v-3.2c0-1.3.9-2.4 2.2-2.6 2.4-.4 4.4-2.6 4.4-5.3 0-2.4-1.6-4.4-3.5-4.4-1.1 0-2.1.7-2.8 1.8-.7-1.1-1.8-1.8-3.2-1.8Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M12 16v3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "obgyn":
      return (
        <Base>
          <path
            d="M12 14a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M12 14v7M9 18h6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "dermatology":
      return (
        <Base>
          <path
            d="M12 3c3.2 4 5.8 7.2 5.8 10.2A5.8 5.8 0 1 1 6.2 13.2C6.2 10.2 8.8 7 12 3Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M9.2 13.4c.6.8 1.6 1.3 2.8 1.3s2.2-.5 2.8-1.3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    case "plastic-surgery":
      return (
        <Base>
          <path
            d="M4 16l6-6 4 4-6 6H4v-4Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M13 7l4-4 3 3-4 4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "neurosurgery":
      return (
        <Base>
          <path
            d="M10 5c-2.6 0-4.7 2.1-4.7 4.7 0 1.3.5 2.4 1.3 3.3-.2.4-.3.9-.3 1.4 0 1.7 1.3 3 3 3h1.2v2.6h3V16h1.5c1.7 0 3-1.3 3-3 0-1.2-.6-2.3-1.6-2.8.1-.3.1-.7.1-1 0-2.6-2.1-4.7-4.7-4.7H10Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M9.2 10.3h5.6M10.2 8.3h3.6M10.2 12.3h3.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </Base>
      );

    case "pulmonology":
      return (
        <Base>
          <path
            d="M12 4v8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M12 12c-1.6 0-3.3-3.5-5.4-3.5-1.6 0-2.6 1.5-2.6 3.4 0 4.4 2.9 8.1 6.4 8.1H12"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M12 12c1.6 0 3.3-3.5 5.4-3.5 1.6 0 2.6 1.5 2.6 3.4 0 4.4-2.9 8.1-6.4 8.1H12"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "dentistry":
      return (
        <Base>
          <path
            d="M8.4 4.8c1.1-.7 2.4-.8 3.6-.3 1.2-.5 2.5-.4 3.6.3 1.3.8 1.9 2.4 1.5 3.9l-1.2 5.2c-.3 1.3-1.6 2.2-2.9 2.1-.8-.1-1.5.5-1.6 1.3L11 20h-1l-.6-2.7c-.2-.8-.8-1.4-1.6-1.3-1.4.1-2.6-.8-2.9-2.1L3.7 8.7c-.4-1.5.2-3.1 1.5-3.9Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );

    case "radiology":
      return (
        <Base>
          <path
            d="M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M9 8h6M9 12h6M9 16h4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );

    default:
      return (
        <Base>
          <path
            d="M5 7h14v12H5z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M7 5h10"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </Base>
      );
  }
}
